/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_HeelsInputs */

const en_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heels`)
};

const es_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tacones`)
};

const fr_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talons`)
};

const de_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High Heels`)
};

const ja_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒール`)
};

const zh_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高跟鞋`)
};

const ar_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحذية بكعب`)
};

const id_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepatu Hak`)
};

const it_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tacchi`)
};

const ru_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Туфли на каблуке`)
};

const pt_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltos`)
};

const ko_val_heels = /** @type {(inputs: Val_HeelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`힐`)
};

/**
* | output |
* | --- |
* | "Heels" |
*
* @param {Val_HeelsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_heels = /** @type {((inputs?: Val_HeelsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_HeelsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_heels(inputs)
	if (locale === "es") return es_val_heels(inputs)
	if (locale === "fr") return fr_val_heels(inputs)
	if (locale === "de") return de_val_heels(inputs)
	if (locale === "ja") return ja_val_heels(inputs)
	if (locale === "zh") return zh_val_heels(inputs)
	if (locale === "ar") return ar_val_heels(inputs)
	if (locale === "id") return id_val_heels(inputs)
	if (locale === "it") return it_val_heels(inputs)
	if (locale === "ru") return ru_val_heels(inputs)
	if (locale === "pt") return pt_val_heels(inputs)
	return ko_val_heels(inputs)
});